import type { Mission } from '../missions.ts'

export const ussf: Mission = {
  id: "ussf",
  name: "U.S. Space Force",
  short: "USSF",
  kind: "subagency",
  parent: "dod",
  url: "https://www.spaceforce.mil/",
  established: 2019,
  palette: {
    primary: "#00263a",
    secondary: "#101820",
    accent: "#98a4ae",
  },
  colorSource: {
    kind: "brand-guide",
    url: "https://www.dvidshub.net/image/9471524",
  },
  motif: "delta",
  mission: {
    text: "Our mission is to Secure our Nation’s interests in, from, and to space.",
    url: "https://www.spaceforce.mil/About-Us/",
  },
  fact: {
    text: "The Space Force was established on Dec. 20, 2019, the first new branch of the armed services since 1947.",
    url: "https://www.spaceforce.mil/About-Us/",
  },
  seal: {
    file: "public/seals/ussf.svg",
    source: "https://commons.wikimedia.org/wiki/File:Seal_of_the_United_States_Space_Force.svg",
  },
  logo: {
    file: "public/logos/ussf.svg",
    source: "https://commons.wikimedia.org/wiki/File:United_States_Space_Force_logo.svg",
  },
  identifier: {
    about: "https://www.spaceforce.mil/About-Us/",
    accessibility: "https://www.compliance.af.mil/",
    foia: "https://www.compliance.af.mil/",
    noFear: "https://www.af.mil/Equal-Opportunity/AS/",
    oig: "https://www.afinspectorgeneral.af.mil/",
    performance: "https://www.performance.gov/agencies/dod",
    privacy: "https://www.compliance.af.mil/",
  },
  media: {
    photos: [
      {
        file: "/media/ussf-vandenberg-launch.jpg",
        small: "/media/ussf-vandenberg-launch-sm.jpg",
        alt: "A long-exposure streak of orange light arcs into the night sky from a Falcon 9 launch at Vandenberg Space Force Base.",
        title: "Falcon 9 launches the Starlink 17-27 mission from Vandenberg Space Force Base, California, April 14, 2026",
        creator: "2nd Lt. Andrew Taller, U.S. Space Force",
        source: "https://commons.wikimedia.org/wiki/File:Starlink_17-27_Mission_Launches_from_Space_Launch_Complex_4_at_Vandenberg_Space_Force_Base_(9617040).jpg",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/ussf-new-glenn.jpg",
        small: "/media/ussf-new-glenn-sm.jpg",
        alt: "A New Glenn rocket climbs over the ocean at night, its exhaust plume glowing blue against a dark sky.",
        title: "New Glenn launches from Space Launch Complex 36, Cape Canaveral Space Force Station, January 16, 2025",
        creator: "Senior Airman Samuel Becker, U.S. Space Force",
        source: "https://commons.wikimedia.org/wiki/File:New_Glenn_launch_signals_new_era_for_Space_Launch_Complex_36_(8832112).jpg",
        license: "Public domain (U.S. government work)",
      },
    ],
    video: {
      webm: "/media/ussf-loop.webm",
      mp4: "/media/ussf-loop.mp4",
      poster: "/media/ussf-loop-poster.jpg",
      title: "Falcon 9 launches the GPS III-SV09 mission from Cape Canaveral Space Force Station, January 27, 2026",
      creator: "Gwendolyn Kurzen, U.S. Space Force",
      source: "https://commons.wikimedia.org/wiki/File:GPS_III-SV09_Launches_from_Cape_Canaveral_Space_Force_Station_(994178).webm",
      license: "Public domain (U.S. government work)",
    },
  },
}
